import axios from "axios";

export const getLingueApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/lingue/`);
}